import * as z from 'zod';

// The venue ("About") screen is one read-only profile payload: cover, logo,
// name, blurb, geo point and a weekly schedule.

/**
 * A geo point in the backend's `{lat, long}` convention (flipped to
 * `[long, lat]` for ymaps at the widget boundary — see `lib/to-lng-lat`).
 */
export const venueLocationSchema = z.object({
  lat: z.number(),
  long: z.number(),
});
export type VenueLocation = z.infer<typeof venueLocationSchema>;

/**
 * One weekday's opening hours. `label` is a weekday key ("mon"–"sun"),
 * translated at render time via `venue.weekdays.<label>`; `hours` arrives
 * preformatted from the backend as a range ("09:30 - 22:45").
 */
export const venueHoursSchema = z.object({
  label: z.string(),
  hours: z.string(),
  orderFrom: z.string().optional(),
  orderTo: z.string().optional(),
});
export type VenueHours = z.infer<typeof venueHoursSchema>;

export const venueSchema = z.object({
  name: z.string(),
  description: z.string(),
  coverUrl: z.string(),
  /** Square brand logo URL (rendered cropped to a circle). */
  logoUrl: z.string(),
  address: z.string().optional(),
  location: venueLocationSchema,
  workingHours: z.array(venueHoursSchema),
});
export type Venue = z.infer<typeof venueSchema>;
